var inProgress = {};
// data-webpack is not used as build has no uniqueName
// loadScript function to load a script via script tag
__webpack_require__.l = (url, done, key, chunkId) => {
function load_script(fallback){
                        var host = get_host(url);
                        var file_url = url;
                        if (!fallback && host && window.pub_config)
                        {
                            var cdn_file = file_url.split(host)[1];
                            var cdn_file_processed =
                                window.pub_config.url2md5(cdn_file);
                            if (cdn_file!=cdn_file_processed)
                            {
                                file_url = location.protocol
                                    + cdn_file_processed;
                                url = file_url;
                            }
                        }
                        if (fallback && host && host!=location.host)
                            url = url.replace(host, location.host);
	if(inProgress[url]) { inProgress[url].push(done); return; }
	var script, needAttach;
	if(key !== undefined) {
		var scripts = document.getElementsByTagName("script");
		for(var i = 0; i < scripts.length; i++) {
			var s = scripts[i];
			if(s.getAttribute("src") == url) { script = s; break; }
		}
	}
	if(!script) {
		needAttach = true;
		script = document.createElement('script');

		script.charset = 'utf-8';
		script.timeout = 120;
		if (__webpack_require__.nc) {
			script.setAttribute("nonce", __webpack_require__.nc);
		}


		script.src = url;
	}
	inProgress[url] = [done];
	var onScriptComplete = (prev, event) => {
		// avoid mem leaks in IE.
		script.onerror = script.onload = null;
		clearTimeout(timeout);
		var doneFns = inProgress[url];
		delete inProgress[url];
		script.parentNode && script.parentNode.removeChild(script);
		function fallback_load() {
                                var info = {location: location.href,
                                    src: script.src, type: event.type};
                                if (!fallback)
                                {
                                    window.hola_config.perr({id:
                                        'www_hola_webpack_err', info: info});
                                    return load_script(true);
                                }
                                window.hola_config.perr({id:
                                    'www_hola_webpack_err_fin', info: info});
                            }
                            doneFns && doneFns.forEach((fn=>fn(event, fallback_load, fallback)));
		if(prev) prev(event, fallback_load);
	}
	var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
	script.onerror = onScriptComplete.bind(null, script.onerror);
	script.onload = onScriptComplete.bind(null, script.onload);
	needAttach && document.head.appendChild(script);
}
                        load_script();
};